import { features } from '@/lib/features';
import {
  REBRAND_T1_ACTIVE_COLOR,
  REBRAND_T1_HOVER_COLOR,
  REBRAND_T1_PRIMARY_COLOR,
  REBRAND_T1_PRIMARY_INPUT_BORDER,
  REBRAND_T1_PRIMARY_T1_HOVER_SWITCH,
  REBRAND_T1_SELECTION_COLOR,
} from '@/styles';
import styled from '@emotion/styled';
import { Switch } from '@paypalcorp/pp-react-switch-weasley-v7';
import React from 'react';

export const OnboardSwitch = styled(Switch)`
  span {
    font-size: 14px;
    font-weight: 600;
  }
`;

export const RebrandSwitch = styled(Switch)`
  input ~ label {
    background-color: ${REBRAND_T1_ACTIVE_COLOR};
    border-color: ${REBRAND_T1_PRIMARY_INPUT_BORDER};
  }

  /* Select switch control on hover */
  input ~ label:hover {
    background-color: ${REBRAND_T1_PRIMARY_T1_HOVER_SWITCH};
  }

  /* Select the sliding circle on the switch */
  input ~ span {
    border-color: ${REBRAND_T1_PRIMARY_INPUT_BORDER};
  }

  /* Select switch control while it's checked */
  input:checked ~ label {
    background-color: ${REBRAND_T1_PRIMARY_COLOR};
    border-color: ${REBRAND_T1_PRIMARY_COLOR};
  }

  /* Select switch control when checked and on hover */
  input:checked ~ label:hover {
    background-color: ${REBRAND_T1_HOVER_COLOR};
  }

  /* Select the sliding circle when it's checked */
  input:checked ~ span {
    border-color: ${REBRAND_T1_PRIMARY_COLOR};
  }

  /* Select the checkmark inside the circle when it's checked */
  input:checked ~ span > span {
    color: ${REBRAND_T1_PRIMARY_COLOR};
  }

  /* Select the whole switch when focused */
  input:focus {
    outline-color: ${REBRAND_T1_SELECTION_COLOR};
  }
`;
// Unified Switch Component
export const SwitchComponent: React.FC<React.ComponentProps<typeof Switch>> = (
  props: React.ComponentProps<typeof Switch>,
): React.ReactElement => {
  const hasRebrandColorTreatment = features.isActive(
    'hasRebrandColorTreatment',
  );

  // Dynamically render the correct styled component based on the feature flag
  const Component = hasRebrandColorTreatment ? RebrandSwitch : OnboardSwitch;

  return <Component {...props} />;
};
